export default function formatNumber(n) {
    return String(n).replace(/(.)(?=(\d{3})+$)/g,'$1,');
}